import type { OnboardingV3FitnessScore } from "./onboardingV3Types";

export function mapFitnessScoreToRadarProps(score: OnboardingV3FitnessScore): {
  total: number;
  control: number;
  safety: number;
  growth: number;
} {
  return {
    total: score.total,
    control: score.control,
    safety: score.safety,
    growth: score.growth,
  };
}
